import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShoppingBag2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shopping-bag-2"><path fillRule="evenodd" clipRule="evenodd" d="M8.00012 6C8.00012 3.79086 9.79098 2 12.0001 2C14.2093 2 16.0001 3.79086 16.0001 6V7.09439C17.4775 7.43248 18.6411 8.646 18.8713 10.2004L19.9825 17.7004C20.318 19.9656 18.5628 22 16.2729 22H7.72732C5.43743 22 3.68222 19.9656 4.0178 17.7004L5.12891 10.2004C5.3592 8.646 6.52277 7.43249 8.00012 7.09439V6ZM9.50012 7H14.5001V6C14.5001 4.61929 13.3808 3.5 12.0001 3.5C10.6194 3.5 9.50012 4.61929 9.50012 6V7Z" fill="currentColor"/></CentralIconBase>;
};

export default IconShoppingBag2;
